export const CAMERA_BLACK_LUMA = 4
export const CAMERA_MAX_REVIVES = 3

export function cameraTrackOk({trackLive, trackMuted, videoWidth, readyState}) {
  return Boolean(trackLive) && !trackMuted && videoWidth > 0 && readyState >= 2
}

export function cameraLit(meanLuma, black = CAMERA_BLACK_LUMA) {
  return Number.isFinite(meanLuma) && meanLuma >= black
}

/**
 * A live track with dimensions is not a picture. iOS 18 can report
 * `readyState: "live"` and `videoWidth > 0` while `muted` and painting black —
 * that is what the 2026-10-22 fountain walks recorded.
 */
export function cameraPictureOk({trackLive, trackMuted, videoWidth, readyState, meanLuma}) {
  if (!cameraTrackOk({trackLive, trackMuted, videoWidth, readyState})) return false
  if (meanLuma == null) return true
  return cameraLit(meanLuma)
}

export function sampleVideoLuma(video, canvas, ctx) {
  if (!video || !ctx || !canvas) return null
  if (!(video.videoWidth > 0) || !(video.videoHeight > 0)) return null
  try {
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data
    let sum = 0
    const n = canvas.width * canvas.height
    for (let i = 0; i < data.length; i += 4) {
      sum += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]
    }
    return sum / n
  } catch {
    return null
  }
}
